var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortCutKeysTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1127.422,
    height: 30.371,
    viewBox: "0 0 1127.422 30.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6660"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 662",
    d: "M15.659 0 1015.8-.371V30H0z",
    transform: "translate(111.62 .371)",
    style: {
      fill: "#1c314c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 663",
    d: "M19.333 0H59.12L39.577 30H0z",
    transform: "translate(0 .371)",
    style: {
      fill: "#1c314c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 664",
    d: "M18.712 0h38.507L38.3 30H0z",
    transform: "translate(54.401 .371)",
    style: {
      fill: "#ffa539"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Shortcut Keys",
    transform: "translate(539 23)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      fontSize: 21,
      fontFamily: "Roboto-Bold,Roboto",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Shortcut Keys")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortCutKeysTitle);
export default __webpack_public_path__ + "static/media/shortCutKeysTitle.8642559972edfa2b4144f14b4961f6e6.svg";
export { ForwardRef as ReactComponent };